import React, { useEffect, useState } from "react";
import TwoFactorMFAForm from "./TwoFactorMFAForm";
import { useTranslation } from "react-i18next";

interface IProps {
    displayData: any;
    registrationState: any;
    setRegistrationState: any;
    manage: any;
}

const TwoFactorMFA = ({ displayData, registrationState, setRegistrationState, manage }: IProps) => {
    const { t: tLang } = useTranslation();

    const [state, setState] = useState({ maximumAttemptReached: false });
    useEffect(() => {
        setState({ ...state, maximumAttemptReached: registrationState.twoFactorMFA.maximumAttemptReached });
    }, [registrationState.twoFactorMFA.maximumAttemptReached]);

    return (
        <div className="row" id="content">
            <div className="col-xs">
                {/*   {state.maximumAttemptReached && <div className="notice-container status-warning notice-xs" role="alert" aria-atomic="true">
                    <span role="img" aria-label="info-circle" className="notice-icon"><em className="las la-exclamation-circle"></em></span>
                    <div className="notice-message">Your account is locked!</div>
                    <div className="notice-description">Your account has been temporarily disabled due to repeated unsuccessful login attempts. This is a standard security measure. If you need assistance please contact customer support at (1-888-439-7443). You may also try to login after 15 minutes with the correct password.</div>
                </div>} */}
                <div className="box box-has-shadow offset-padding">
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-icon" aria-hidden="true">
                                <em className="la la-lock"></em>
                            </div>
                            <div className="box-title-text">
                                <h2 className="box-title">{tLang("registration.authentication.title")}</h2>
                            </div>
                        </div>
                    </div>
                    <TwoFactorMFAForm
                        registrationState={registrationState}
                        setRegistrationState={setRegistrationState}
                        manageState={manage}
                        displayData={displayData}
                    ></TwoFactorMFAForm>
                </div>
            </div>
        </div>
    );
};

export default TwoFactorMFA;
